// extracted by mini-css-extract-plugin
export default {"container":"countdown_container__Q-qM7","heading":"countdown_heading__ZzmMh","timer_box":"countdown_timer_box__Yym8k"};